//Generated File 
export default class YesNoDefault{
	static readonly DefaultValue = `DefaultValue`;
	static readonly No = `No`;
	static readonly Yes = `Yes`;
}
